import { Link, ListItem, Text, UnorderedList } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile } from '@sravni/react-utils';

import { CONTACT_EMAIL } from '../../../constants/contacts';
import { Accordion } from '../Accordion';

export const FAQBlock = () => {
  const isMobile = useIsMobile();

  return (
    <Accordion className={isMobile ? 'h-pt-16 h-pb-16' : 'h-pt-32 h-pb-32'}>
      <Accordion.Item title={`Част${isMobile ? 'ые' : 'о задаваемые'} вопросы`}>
        <Accordion background="light">
          <Accordion.Item title="Как зарегистрироваться?">
            <Text>
              Для создания аккаунта в нашем партнерском кабинете - нажмите на кнопку “Регистрация”. В открывшемся окне
              введите действующий номер телефона и контактную информацию.
            </Text>
            <Text>Изучите и примите условия оферты и политику конфиденциальности.</Text>
            <Text>
              Введите код подтверждения, отправленный на указанный номер. Добро пожаловать в партнерский кабинет Сравни.
            </Text>
            <Text>Если у вас уже есть аккаунт в партнерском кабинете сравни - нажмите “Вход”.</Text>
          </Accordion.Item>
          <Accordion.Item title="Могу ли я зайти по старому логину и паролю?">
            <Text>
              Если у вас есть аккаунт в партнерском кабинете на старой странице{' '}
              <Link href="https://partner2.sravni.ru">https://partner2.sravni.ru</Link>, то вы можете войти, используя
              старые данные для входа (номер телефона или email).
            </Text>
          </Accordion.Item>
          <Accordion.Item title="Сохранятся ли мои настройки при входе в новый личный кабинет?">
            <Text>
              Да, все настройки и данные из старого личного кабинета автоматически затянутся в новый личный кабинет.
            </Text>
            <Text>Данные по статистике и конверсиям доступны с 1 января 2024 года.</Text>
          </Accordion.Item>
          <Accordion.Item title="Не могу войти в личный кабинет, что делать?">
            <Text>Если у вас возникли сложности со входом в личный кабинет, то:</Text>
            <UnorderedList>
              <ListItem>
                проверьте выключен ли у вас VPN ( вход в личный кабинет возможен только на территории РФ);
              </ListItem>
              <ListItem>
                проверьте, не открыт ли у вас личный кабинет Сравни, использующий другие данные для входа;
              </ListItem>
              <ListItem>почистите cookie в вашем браузере или зайдите через инкогнито.</ListItem>
            </UnorderedList>
            <Text>
              Если проблема останется, напишите нам на почту{' '}
              <Link href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</Link> и мы обязательно вам поможем.
            </Text>
          </Accordion.Item>
          <Accordion.Item title="Как изменить email или номер телефона?">
            Войдите в личный кабинет Партнерской программы Сравни и зайдите в карточку “Профиля”. В карточке профиля
            измените данные на нужные и подтвердите с помощью кода по sms или email письма подтверждения.
          </Accordion.Item>
          <Accordion.Item title="Забыл пароль?">
            Если ваш аккаунт привязан к номеру телефона, то вход в личный кабинет происходит по коду подтверждения,
            который отправляется на указанный номер. Если ваш аккаунт привязан к email, то нажмите кнопку “Сбросить
            пароль” и на указанный адрес придет письмо для создания нового пароля.
          </Accordion.Item>
          <Accordion.Item title="Какая минимальная сумма выплаты?">
            Минимальная сумма дохода для вывода - 3 000 руб.
          </Accordion.Item>
        </Accordion>
      </Accordion.Item>
    </Accordion>
  );
};
